import React from 'react';
import { curry, get } from 'lodash';
import { Query, Mutation } from 'react-apollo';

import caseDelaysQuery, { NAME as delaysQueryName } from './caseDelaysQuery';
import createCaseDelayMutation from './createCaseDelayMutation';
import updateCaseDelayMutation from './updateCaseDelayMutation';

export const buildMutationChild = curry(
  (WrappedComponent, componentProps, createCaseDelayFn, updateCaseDelayFn) => {
    const { caseId, status } = componentProps;

    const createCaseDelay = ({ reasonType, customReason } = {}) =>
      createCaseDelayFn({
        variables: { caseId, status, reasonType, customReason },
      });

    const updateCaseDelay = delayId =>
      updateCaseDelayFn({
        variables: { delayId, endTime: new Date().toISOString() },
      });

    return (
      <WrappedComponent
        {...componentProps}
        {...{ createCaseDelay, updateCaseDelay }}
      />
    );
  },
);

function buildWrappedComponentWithMutations(WrappedComponent, componentProps) {
  const toRefetch = [delaysQueryName];
  return (
    <Mutation mutation={createCaseDelayMutation} refetchQueries={toRefetch}>
      {createCaseDelay => (
        <Mutation mutation={updateCaseDelayMutation} refetchQueries={toRefetch}>
          {buildMutationChild(
            WrappedComponent,
            componentProps,
            createCaseDelay,
          )}
        </Mutation>
      )}
    </Mutation>
  );
}

export const buildQueryChild = curry(
  (WrappedComponent, componentProps, { data, loading }) =>
    buildWrappedComponentWithMutations(WrappedComponent, {
      ...componentProps,
      assetDowntimeMs: get(data, 'case.assetDowntimeMs'),
      caseDelays: get(data, 'case.caseDelays', []),
      isDelayed: get(data, 'case.isDelayed', false),
      isLoadingCaseDelays: !!loading,
    }),
);

function buildWrappedComponentWithQuery(WrappedComponent, componentProps) {
  const { caseNumber } = componentProps;

  return (
    <Query
      fetchPolicy="cache-and-network"
      skip={!caseNumber}
      query={caseDelaysQuery}
      variables={{ caseNumber }}
    >
      {buildQueryChild(WrappedComponent, componentProps)}
    </Query>
  );
}

const withCaseDelays = curry(buildWrappedComponentWithQuery);

export default withCaseDelays;



// WEBPACK FOOTER //
// ./src/compositions/CaseDetailOverviewPanel/withCaseDelays/index.js